"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSessionSetting = exports.getSessionSetting = exports.navConfigSettingsPreferencesKey = exports.navConfigSettingsKey = exports.expandedSettingsKey = void 0;
var expandedSettingsKey = 'SETTINGS_NAV:EXPANDED_ITEMS';
exports.expandedSettingsKey = expandedSettingsKey;
var navConfigSettingsKey = 'SETTINGS_NAV:NAV_CONFIG';
exports.navConfigSettingsKey = navConfigSettingsKey;
var navConfigSettingsPreferencesKey = 'SETTINGS_PREFERENCES_NAV:NAV_CONFIG';
exports.navConfigSettingsPreferencesKey = navConfigSettingsPreferencesKey;

var getSessionSetting = function getSessionSetting(key) {
  var setting;

  try {
    setting = JSON.parse(window.sessionStorage.getItem(key));
  } catch (e) {
    console.error(e);
  }

  return setting;
};

exports.getSessionSetting = getSessionSetting;

var setSessionSetting = function setSessionSetting(key, value) {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(e);
  }
};

exports.setSessionSetting = setSessionSetting;